<script setup lang="ts">
import type { CmsElementPluebelCmsElementsProjectIdears } from "~/composables/useCustom";
const props = defineProps<{
  content: CmsElementPluebelCmsElementsProjectIdears;
}>();

const { content } = props;

const { getConfigValue } = useCmsElementConfig(content);

const boxes = computed(() => getConfigValue("box"));
</script>
<template>
  <section class="pb-20 md:pb-32 lg:pb-40 xl:pb-52">
    <div class="container">
      <div
        class="text-center cat-slider02 sm:-mx-3 md:-mx-4 m-0 cat-list-wrap lg:flex lg:flex-wrap lg:gap-y-10"
      >
        <template v-for="box in boxes">
          <div class="lg:w-1/3 sm:px-3 md:px-4">
            <div class="mb-6 lg:mb-8 relative">
              <figure class="img-cover aspect-4/3 overflow-hidden rounded-3xl">
                <NuxtImg
                  loading="lazy"
                  format="webp"
                  :src="box.image?.url"
                  alt=""
                />
              </figure>
              <span
                v-if="box.image_label"
                class="absolute top-4 start-5 lg:start-4 font-redit_sans_con font-extrabold px-2 ld:px-3 py-[2px] lg:py-1 bg-cust_cream rounded-lg"
                >{{ box.image_label }}</span
              >
            </div>
            <h3 class="text-28px md:text-3xl lg:text-4xl mb-4 md:mb-6 lg:mb-8 md:min-h-[80px] md:px-8">
              {{ box.text }}
            </h3>
            <SharedButton
              v-if="box.boxbutton"
              :button="box.boxbutton"
              class="btn-primary mt-auto"
            />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
